// extracted by mini-css-extract-plugin
export default {"sort":"zz-z","sortSelect":"Az-z","disabled":"Bz-z"};